import { render, staticRenderFns } from "./student-statistics.vue?vue&type=template&id=8b60bad2&scoped=true"
import script from "./student-statistics.vue?vue&type=script&lang=js"
export * from "./student-statistics.vue?vue&type=script&lang=js"
import style0 from "./student-statistics.vue?vue&type=style&index=0&id=8b60bad2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b60bad2",
  null
  
)

export default component.exports